export default __webpack_public_path__ + "static/media/post-ward.58e5ae04.jpg";